import {Button} from '@hm/fundamental'
import {usePermissionsQuery} from '@hproduce/permissions'
import {mdiPlus} from '@mdi/js'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {hasBulkUploadPlantActionsPermission} from '../../utils'

type Props = {
  onClick: () => void
  className?: string
}

export const BulkUploadPlantActionsButton: React.FC<Props> = ({onClick, className}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {data: permissions} = usePermissionsQuery()

  if (!hasBulkUploadPlantActionsPermission(permissions ?? [])) {
    return null
  }

  return (
    <Button
      type="button"
      variant="primary"
      size="large"
      icon={mdiPlus}
      iconPosition="left"
      onClick={onClick}
      className={className}
      data-test-id="bulk_upload_plant_actions_button"
    >
      <span className="flex flex-col items-start">
        <span className="text-14px leading-18px">{t('pomAction.bulkUpload.action.openLine1')}</span>
        <span className="text-12px leading-16px font-normal">
          {t('pomAction.bulkUpload.action.openLine2')}
        </span>
      </span>
    </Button>
  )
}
